import React from 'react';
import '../styles/Contacto.css';

const Contacto: React.FC = () => {
  return (
    <section className="pagina-contenedor">
      <h2 className="titulo-seccion">Contáctanos</h2>
      <p className="descripcion-seccion">
        ¿Tienes dudas, sugerencias o necesitas ayuda con tu pedido? 
        Completa el formulario o escríbenos directamente. ¡Estamos para ayudarte!
      </p>

      <form
        className="formulario-contacto"
        onSubmit={(e) => {
          e.preventDefault();
          alert('Mensaje enviado. ¡Gracias por contactarnos!');
        }}
      >
        <label>
          Nombre
          <input type="text" required placeholder="Tu nombre completo" />
        </label>
        <label>
          Correo electrónico
          <input type="email" required placeholder="tucorreo@ejemplo.com" />
        </label>
        <label>
          Mensaje
          <textarea required placeholder="Escribe tu mensaje aquí..." />
        </label>
        <button type="submit" className="boton-enviar">Enviar mensaje</button>
      </form>

      <div className="info-contacto">
        <p><strong>Email:</strong> contacto@prodnook.cl</p>
        <p><strong>WhatsApp:</strong> +56 9 4238 0631</p>
      </div>
    </section>
  );
};

export default Contacto;
